import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useHistory } from 'react-router';
import useLogout from 'hooks/useLogout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSignOutAlt, faKey } from '@fortawesome/free-solid-svg-icons';
import Dropdown from 'components/Dropdown';
import { routeProps as changePasswordRouteProps } from 'containers/paths/ChangePasswordPath';

const MenuLabel = styled(FontAwesomeIcon)`
  font-size: 1.4rem;
`;

const UserMenu = ({ className }) => {
  const performLogout = useLogout();
  const history = useHistory();

  function changePassword() {
    history.push(changePasswordRouteProps.path);
  }
  const userOptions = [
    {
      key: 'changePassword',
      label: (
        <>
          <FontAwesomeIcon icon={faKey} />
          Change password
        </>
      ),
      dataLayer: {
        action: 'Change Password Click',
        label: 'Change Password',
      },
      onClick: changePassword,
    },
    {
      key: 'logout',
      label: (
        <>
          <FontAwesomeIcon icon={faSignOutAlt} />
          Logout
        </>
      ),
      dataLayer: {
        action: 'Logout Click',
        label: 'Logout',
      },
      onClick: () => {
        performLogout();
      },
    },
  ];

  const classes = ['UserMenu'];
  if (className) classes.push(className);

  return (
    <Dropdown
      className={classes.join(' ')}
      labelComponent={<MenuLabel icon={faUser} />}
      dataLayer={{ action: 'Account Logo Click', label: 'Account Logo Click' }}
      options={userOptions}
    />
  );
};

UserMenu.displayName = 'UserMenu';

UserMenu.propTypes = {
  className: PropTypes.string,
};

UserMenu.defaultProps = {
  className: null,
};

export default UserMenu;
